import { doc, onSnapshot, setDoc } from 'firebase/firestore';
import { db } from '../../firebase';

export const listenPageContent = (pageId, callback) => {
  const docRef = doc(db, 'contenuDuSite', pageId);
  return onSnapshot(docRef, (snapshot) => {
    callback(snapshot.data()?.i18n || null);
  });
};

export const savePageContent = async (pageId, i18nData) => {
  const docRef = doc(db, 'contenuDuSite', pageId);
  await setDoc(docRef, { i18n: i18nData }, { merge: true });
};
